// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57cf31fa","952":"422a773e"}[chunkId] + ".chunk.js";
};